<router-outlet></router-outlet>
<app-toast></app-toast>
<p-confirmDialog [header]="'common.confirm' | translate"
                 styleClass="page confirm-dialog"
                 acceptButtonStyleClass="btn-primary"
                 rejectButtonStyleClass="btn-primary">
</p-confirmDialog>